import Image from "next/image";
import ContactForm from "./contactForm";

const offices = [
  {
    "name": "Navi Mumbai Branch",
    "address": "Office No: 508, Niharika Mirage D, 5th Floor, Plot No. 274, Kharghar, Navi Mumbai - 410210, Maharashtra",
    "emails": ["navimumbai@email.com"],
    "phones": ["+91 9876543210"]
  },
  {
    "name": "Pen Branch",
    "address": "Gurusankalp Building, Plot Number 66, Mhada Colony, Mumbai - Goa Hwy, Mahamarg, Pen - 402107, Maharashtra",
    "emails": ["penbranch@email.com"],
    "phones": ["+91 9123456780"]
  },
  {
    "name": "Uran Branch",
    "address": "Ashva Education, Bokadvira, near Uran police chowk, Bokadvira, Uran - 400702, Maharashtra",
    "emails": ["uranbranch@email.com"],
    "phones": ["+91 9012345678"]
  }
]


const ContactInfoArea = () => {
  return (
    <div className="contact-info-area bg-f3f3f3 ptb-120 border-bottom">
      <div className="container px-0">
        <div className="row mx-0">
          <div className="col-lg-8 col-md-12">


              <ContactForm />
            {/* <div className="contact-info-content">
              <div className="content">
                     <div className="row">
  {offices.slice(0, 2).map((office) => (
    <div className="col-lg-6 col-sm-6 mb-4" key={office.name}>
      <div className="box">
        <h3 className="fw-semibold fs-5">{office.name}</h3>
        <ul className="p-0 m-0 list-unstyled fs-6">
          <li className="position-relative">
            <Image
              width={20}
              height={20}
              src="/images/icons/office.svg"
              alt="office"
            />
            {office.address}
          </li>
          <li className="position-relative">
            <Image
              width={20}
              height={14}
              src="/images/icons/email2.svg"
              alt="email"
            />
            {office.emails.map((email, i) => (
              <span key={email}>
                <a href={`mailto:${email}`}>{email}</a>
                {i < office.emails.length - 1 && <br />}
              </span>
            ))}
          </li>
          <li className="position-relative">
            <Image
              width={20}
              height={20}
              src="/images/icons/bv.svg"
              alt="phone"
            />
            {office.phones.map((phone, i) => (
              <span key={phone}>
                <a href={`tel:${phone}`}>{phone}</a>
                {i < office.phones.length - 1 && <br />}
              </span>
            ))}
          </li>
        </ul>
      </div>
    </div>
  ))}
</div>

<div className="row justify-content-center">
      {offices.slice(2, 3).map((office) => (
    <div className="col-lg-6 col-sm-6 mb-4" key={office.name}>
      <div className="box">
        <h3 className="fw-semibold fs-5">{office.name}</h3>
        <ul className="p-0 m-0 list-unstyled fs-6">
          <li className="position-relative">
            <Image
              width={20}
              height={20}
              src="/images/icons/office.svg"
              alt="office"
            />
            {office.address}
          </li>
          <li className="position-relative">
            <Image
              width={20}
              height={14}
              src="/images/icons/email2.svg"
              alt="email"
            />
            {office.emails.map((email, i) => (
              <span key={email}>
                <a href={`mailto:${email}`}>{email}</a>
                {i < office.emails.length - 1 && <br />}
              </span>
            ))}
          </li>
          <li className="position-relative">
            <Image
              width={20}
              height={20}
              src="/images/icons/bv.svg"
              alt="phone"
            />
            {office.phones.map((phone, i) => (
              <span key={phone}>
                <a href={`tel:${phone}`}>{phone}</a>
                {i < office.phones.length - 1 && <br />}
              </span>
            ))}
          </li>
        </ul>
      </div>
    </div>
  ))}

</div>
 

              </div>
            </div> */}
          </div>
          <div className="col-lg-4 col-md-12 px-2">
            <div className="contact-info ">
              <Image
                width={1380}
                height={1356}
                sizes="100vw"
                src="/images/contact/c4.jpg"
                alt="contact-info-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoArea;
